module.exports = __webpack_public_path__ + "static/img/image2.png.e0b22b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image2.png.png
// module id = XR0d
// module chunks = 14